import { Component, OnInit } from '@angular/core';
import { AccountClientSimplifiedService } from "../../service/account-client-simplified.service";
import { FlashMessagesService } from "angular2-flash-messages/module";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'app-account-client-simplified',
  templateUrl: './account-client-simplified.component.html',
  styleUrls: ['./account-client-simplified.component.scss'],
  providers: [AccountClientSimplifiedService]
})
export class AccountClientSimplifiedComponent implements OnInit {

private idAccountClient = ''
private subscription: any;
private token;

public accountClientDetails = {
  AdiantamentoLC: '',
  Apelido: '',
  Bairro: '',
  BloqueioManual: '',
  CEP: '',
  Cidade: '',
  ClientePremium: '',
  CodigoPrincipal: '',
  Complemento: '',
  ContaClienteEstruturaComercial: [],
  ContaClienteFinanceiro: [],
  ContaClienteRepresentante: [],
  Contato: '',
  DataNascimentoFundacao: '',
  Documento: '',
  Email: '',
  Endereco: '',
  GrupoEconomicos: [],
  ID: '',
  Nome: '',
  Numero: '',
  OutrosCodigo: [],
  Pais: '',
  PropostaLcs: [],
  RestricaoSerasa: '',
  SegmentoID: '',
  TOP10: '',
  Telefone: '',
  TipoClienteID: '',
  UF: ''};
  
  constructor(private accountClientSimplifiedService: AccountClientSimplifiedService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
    this.token = localStorage.getItem('yara.token');
   }

  ngOnInit() {
    this.subscription = this.route.params.subscribe(params => {
			this.idAccountClient = params['guid'];
    });
    
    this.getAccountClientDetails();    
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  getAccountClientDetails() {
		this.accountClientSimplifiedService.getAccountClientDetails(this.token, this.idAccountClient).subscribe(result => {
			if (result.Success) {
				this.accountClientDetails = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
	}, error => {
			console.log(error);
			
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/account-client-simplified/component/account-client-simplified/account-client-simplified.component.ts